module.exports = __webpack_public_path__ + "media/images/pages/school/schedule-1f3307d5dbd3336deda3d7f51829e585.png";